exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nimg[data-v-1bb26bb0] {\n    width: 100%;\n    height: 135px;\n}\n.mobile-hs > li[data-v-1bb26bb0],\n.mobile-item[data-v-1bb26bb0] {\n    scroll-snap-align: center;\n    /*padding: calc(var(--gutter) / 2 * 1.5);*/\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    /*align-items: center;*/\n    /*background: #fff;*/\n    border-radius: 12px;\n    overflow: hidden;\n}\n\n", ""]);

// exports
